import apiFetch from '../apiFetch'

export default function (body, dossierStageId, token) {
  return apiFetch({ endPoint: 'DossierStage/' + dossierStageId, method: 'PUT', body: body, token: token })
}
